// Copyright (c) 2021 WiseTime. All rights reserved.

import * as TimelineSlice from "features/timeline/slices/timeline"
import React, { memo } from "react"
import { useDispatch, useSelector } from "react-redux"
import { DateLinkWrapper, DateLink, DateLabel } from "../../shared/styles"
import {
  convertTimelineDateToTimelinePathDate,
  getCurrentDate,
  isFutureDate,
  TimelineDate,
  TODAY_DATE_PARAM,
} from "features/timeline/dateTime"
import LabelMatched from "./LabelMatched"
import DateTabIndicator from "./DateTabIndicator"
import { ROUTE_PATH } from "app/routing"
import { Trans } from "@lingui/react"

type Props = {
  dateLabel: string,
  timelineDate: TimelineDate,
  isActive: boolean,
  showMatchedLabel: boolean,
}

const DateTab = ({
  dateLabel,
  timelineDate,
  isActive,
  showMatchedLabel,
}: Props): React.ReactElement<Props> => {
  const dispatch = useDispatch()
  const currentDay = useSelector(TimelineSlice.selectCurrentDay)

  const getClassNames = (): string => (
    `${getCurrentDate() === timelineDate ? "is-today" : ""}`
  )
  const onClick = (): void => {
    dispatch(TimelineSlice.setActiveDate(timelineDate))
  }
  const renderLabel = () => {
    if (currentDay === timelineDate) {
      return <Trans id="label_today" message="Today"/>
    }
    return dateLabel
  }

  const getToUrl = () => {
    if (currentDay === timelineDate) {
      return ROUTE_PATH.TIMELINE.path.replace(":date?", TODAY_DATE_PARAM)
    }
    return ROUTE_PATH.TIMELINE.path.replace(":date?", convertTimelineDateToTimelinePathDate(timelineDate))
  }

  return (
    <DateLinkWrapper isActive={isActive}>
      <DateLink
        to={getToUrl()}
        activeClassName="is-active"
        className={getClassNames()}
        onClick={onClick}
        replace={isActive}
      >
        <DateLabel>
          {renderLabel()}
          {showMatchedLabel && <LabelMatched timelineDate={timelineDate}/>}
        </DateLabel>
        <DateTabIndicator isFuture={isFutureDate(timelineDate)} timelineDate={timelineDate} />
      </DateLink>
    </DateLinkWrapper>
  )
}

export default memo(DateTab)
